var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStrategicEnablersDisabled(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bulk/status-up",
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "status-up"
  }, /*#__PURE__*/React.createElement("g", {
    id: "status-up_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.4,
    d: "M14.19 0H5.81C2.17 0 0 2.17 0 5.81V14.18C0 17.83 2.17 20 5.81 20H14.18C17.82 20 19.99 17.83 19.99 14.19V5.81C20 2.17 17.83 0 14.19 0Z",
    fill: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4.87988 16.9001C4.46988 16.9001 4.12988 16.5601 4.12988 16.1501V14.0801C4.12988 13.6701 4.46988 13.3301 4.87988 13.3301C5.28988 13.3301 5.62988 13.6701 5.62988 14.0801V16.1501C5.62988 16.5701 5.28988 16.9001 4.87988 16.9001Z",
    fill: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M10 16.9C9.59 16.9 9.25 16.56 9.25 16.15V12C9.25 11.59 9.59 11.25 10 11.25C10.41 11.25 10.75 11.59 10.75 12V16.15C10.75 16.57 10.41 16.9 10 16.9Z",
    fill: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M15.1201 16.8999C14.7101 16.8999 14.3701 16.5599 14.3701 16.1499V9.92993C14.3701 9.51993 14.7101 9.17993 15.1201 9.17993C15.5301 9.17993 15.8701 9.51993 15.8701 9.92993V16.1499C15.8701 16.5699 15.5401 16.8999 15.1201 16.8999Z",
    fill: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M15.87 3.8201C15.87 3.7701 15.85 3.7101 15.84 3.6601C15.83 3.6201 15.82 3.5701 15.81 3.5301C15.79 3.4901 15.76 3.4601 15.74 3.4201C15.71 3.3801 15.68 3.3301 15.64 3.3001C15.63 3.2901 15.63 3.2801 15.62 3.2801C15.59 3.2601 15.56 3.2501 15.53 3.2301C15.49 3.2001 15.44 3.1701 15.39 3.1501C15.34 3.1301 15.29 3.1301 15.24 3.1201C15.2 3.1101 15.17 3.1001 15.13 3.1001H12.2C11.79 3.1001 11.45 3.4401 11.45 3.8501C11.45 4.2601 11.79 4.6001 12.2 4.6001H13.45C11.07 7.1001 8.06998 8.8601 4.69998 9.7101C4.29998 9.8101 4.04998 10.2201 4.14998 10.6201C4.22998 10.9601 4.53998 11.1901 4.87998 11.1901C4.93998 11.1901 4.99998 11.1801 5.05998 11.1701C8.62998 10.2801 11.82 8.4301 14.37 5.8101V6.7801C14.37 7.1901 14.71 7.5301 15.12 7.5301C15.53 7.5301 15.87 7.1901 15.87 6.7801V3.8501C15.87 3.8401 15.87 3.8301 15.87 3.8201Z",
    fill: "#7C7C7C"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrategicEnablersDisabled);
export default __webpack_public_path__ + "static/media/strategicEnablersDisabled.abc638095d8caec09640c58d2c3553bb.svg";
export { ForwardRef as ReactComponent };